import React from 'react';
import { releaseNotes } from '../../config';

const ReleaseNotesModal = ({ isOpen, onClose }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center p-4">
            <div className="bg-white rounded-lg max-w-2xl w-full max-h-[90vh] flex flex-col">
                <div className="p-5 border-b">
                    <h2 className="text-2xl font-bold text-center">Release Notes</h2>
                </div>
                <div className="flex-1 overflow-y-auto p-5">
                    <div className="space-y-4">
                        {releaseNotes.map((note, index) => (
                            <div key={index}>
                                <h3 className="text-xl font-semibold">{note.version} ({note.date})</h3>
                                <ul className="list-disc list-inside mt-2 text-left">
                                    {note.features.map((feature, fIndex) => (
                                        <li key={fIndex}>{feature}</li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="p-5 border-t text-center">
                    <button
                        onClick={onClose}
                        className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                    >
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ReleaseNotesModal;
